import { Observable } from 'rxjs'
import { SourceKey } from '../models/source-key.model'
import { WorkbenchRow } from '../models/workbench-row.model'
import { QuerySort, RequestFilter } from '../models/transactions-query.model'

/**
 * Seam between the workbench UI and the Flex Transactions read API, mirroring the
 * {@link FieldCatalogService} seam.
 *
 * Rows are fetched per source, and only after that source's column catalog has resolved: the
 * request names the fields it wants, and those names come from the catalog. The catalog is also what
 * says which bucket each filter and sort belongs in (its per-column `isDynamic`), and the server
 * deliberately validates neither field names nor types — so a wrong answer here is silent.
 *
 * Clearwater has no read endpoint, so it resolves to no rows, the same shape as its empty catalog.
 */
export abstract class WorkbenchDataSource {
  /**
   * Fetch one page of rows for a source.
   *
   * @param source which grid source to query
   * @param fields field names to select — the catalog's `field` values plus the ids the workbench
   *               always needs. An empty list means the catalog has not resolved yet, so there is
   *               nothing meaningful to ask for.
   * @param filter the two-bucket filter payload from `buildRequestFilter`, or null for unfiltered
   * @param sort   the sort array from `buildSort` in precedence order, or null for the endpoint's own
   *               default order
   */
  abstract load(
    source: SourceKey,
    fields: string[],
    filter?: RequestFilter | null,
    sort?: QuerySort[] | null,
  ): Observable<WorkbenchRow[]>
}
